var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"chart-wrap"},[_c('div',{ref:"chartRef",staticClass:"pie-chart",style:(("width: 100%; height: " + (typeof _vm.height === 'number' ? _vm.height + 'px' : _vm.height)))})])}
var staticRenderFns = []

export { render, staticRenderFns }